<template>
  <div class="container">
    <div v-if="LiveState == 0 || LiveState == 2">
      <div class="zhezhao"></div>
      <div class="palybefore">
        <div class="play-center">
          <h1 v-if="LiveState != 2">直播即将开播，请耐心等待</h1>
          <div class="settimeout" v-if="LiveState != 2">
            <p>倒计时</p>
            <div class="timekuang">{{stillTime(0)}}天</div>
            <div class="timekuang">{{stillTime(1)}}小时</div>
            <div class="timekuang">{{stillTime(2)}}分钟</div>
            <div class="timekuang">{{stillTime(3)}}秒</div>
          </div>
          <div
            class="subscribe"
            @click="Subcribe"
            :class="{ isAlreadySucscirbe: newLiveRoom.isSubScript == 1 }"
          >
            {{ subs }}
          </div>
        </div>
      </div>
    </div>
    <div class="demo" v-if="LiveState == 1">
      <vue-aliplayer-v2
        class="multiple-player"
        key="x"
        ref="VueAliplayerV2"
        :options="options"
      />
    </div>
    <el-tabs v-model="activeName">
      <el-tab-pane label="详情" name="first">
        <div class="details_content">
          <h1>中国肿瘤大会直播预告</h1>
          <p>开始时间3月10日 18:00 (周四)</p>
          <p>观看量：3422人次</p>
          <div class="detauls_content">详情简介</div>
          <img :src="newLiveRoom.detail_live_url" alt="" />
        </div>
      </el-tab-pane>
      <el-tab-pane label="扫码进群" name="second">
        <img :src="newLiveRoom.wechat_live_url" alt="" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import resourcereq from "@/api/resources";
import VueAliplayerV2 from "vue-aliplayer-v2";
import onlinePlay from "@/api/LivePlay";
//videojs.options.flash.swf = "https://cdn.bootcss.com/videojs-swf/5.4.1/video-js.swf"
// 设置flash路径，Video.js会在不支持html5的浏览中使用flash播放视频文件
export default {
  components: {
    VueAliplayerV2,
  },
  data() {
    return {
      LiveState: 0, //当前直播状态。0 是未开始，1是正在直播，2是已结束
      onlinetime: "2022/3/10 18:00", //上线时间
      nowtimes: "", //当前时间
      activeName: "first",
      options: {
        source: "http://live.weijiaoy.com/xxy/zrjlh_prd.m3u8",
        height: "800px",
        // source:'//player.alicdn.com/video/aliyunmedia.mp4',
        isLive: true, //切换为直播流的时候必填（true-直播状态，false-普通模式，播放器普通视频）
      },
      show: true,
      isShowMultiple: false,
      newLiveRoom: {}, //直播间详情信息
      userId: "", //用户ID
    };
  },
  methods: {
    timeFrom(time) {
      //计算当前时间。
      this.nowtimes = this.$moment(time).format("YYYY/MM/DD HH:mm:ss");
    },
    nowtime() {
      //重复计算
      this.timeFrom(new Date());
      setTimeout(() => {
        this.nowtime();
      }, 1000);
      this.creal();
    },
    creal() {
      clearTimeout(this.nowTimes); //清楚当前时间
      this.nowTimes = null;
    },
    async Subcribe() {
      //如果是未订阅且直播未开始的时候，可以订阅
      if (this.LiveState == 0 && this.newLiveRoom.isSubScript == 2) {
        let parmasr = {
          liveId: this.newLiveRoom.id,
          userID: this.userId,
          isSubscript: "1",
          systemSource: "khy",
          actionSource: "web",
        };
        onlinePlay.updateLiveSubScript(parmasr).then(() => {
          this.newLiveRoom.isSubScript = "1";
        });
        this.$message.success("");
        this.$message.success("订阅成功");
      }
      if (this.LiveState == "2") {
        console.log("直播回放");
        let parma = {
          name: this.newLiveRoom.history_live_url,
        };
        this.LiveState = 1;
        this.options.isLive = false;
        let resurl = await resourcereq.getnoVideoURL(parma);
        this.options.source = resurl.data.Data.url;
        console.log(resurl);
      }
    },
    async getLiveDitail() {
      let userid = window.location.href.split("=")[1];
      this.userId = userid;
      let parms = {
        userID: userid,
      };
      let res = await onlinePlay.getIndexLiveRoom(parms);
      let newobj = res.data.Data[0]; //海报信息
      this.LiveState = newobj.live_state;
      parms.appName = newobj.app_name;
      parms.streamName = newobj.stream_name;
      let resDatial = await onlinePlay.getLiveRoomDetail(parms);
      this.newLiveRoom = resDatial.data.Data;
      this.options.source = resDatial.data.Data.liveM3U8
      console.log(res);
    },
  },
  computed: {
    subs() {
      if (this.LiveState == "2") {
        return "直播已结束，点击观看回放";
      }
      if (this.newLiveRoom.isSubScript == "1") {
        return "已订阅直播";
      } else if (this.newLiveRoom.isSubScript == "2") {
        return "订阅直播";
      } else {
        return "订阅直播";
      }
    },
    stillTime() {
      const mm = this.$moment(new Date(this.onlinetime)).diff(
        new Date(this.nowtimes),
        "minutes"
      );
      const ss = this.$moment(new Date(this.onlinetime)).diff(
        new Date(this.nowtimes),
        "seconds"
      ); //秒数
      const hh = Math.floor(mm / 60); //相差的小时数
      const h = hh % 24; //相差的小时差余
      const d = Math.floor(mm / 60 / 24); //相差的天数
      const mmm = mm % 60; //计算相差小时后余下的分钟数
      const s = ss % 60; //计算时间余数。
      return function (params) {
        switch (params) {
          case 0:
            return d
          case 1:
            return h
          case 2:
            return mmm
          case 3:
            return s
            
        }
      }
    },
  },
  created() {
    this.getLiveDitail();
    this.nowtime();
  },
};
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  height: 100%;
  padding: 20px;
  &::-webkit-scrollbar {
    display: none; /* Chrome Safari */
  }
}
.zhezhao {
  width: 98%;
  height: 800px;
  position: absolute;
  background-color: rgba($color: #000000, $alpha: 0.7);
  z-index: 2001;
}
.palybefore {
  //  padding: 20px;
  width: 100%;
  height: 800px;
  background-image: url("../../assets/live/liveback.png");
  display: flex;
  justify-content: center;
  align-items: center;
}
.play-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  h1 {
    position: relative;
    z-index: 2002;
    color: white;
  }
  .settimeout {
    color: rgb(255, 255, 255);
    position: relative;
    z-index: 2002;
    display: flex;
    align-items: center;
    margin-top: 30px;
    font-size: 26px;
    .timekuang {
      margin-left: 30px;
      width: 100px;
      height: 70px;
      line-height: 70px;
      padding-left: 10px;
      border: 1px solid #ffffff;
      opacity: 1;
      border-radius: 5px;
    }
  }
  .silltime {
    //   position: absolute;
    display: flex;
    bottom: 550px;
    left: 800px;
    z-index: 2002;
    color: #ffffff;
    font-size: 28px;
    font-family: Microsoft YaHei;
  }
  .subscribe {
    position: relative;
    margin-top: 40px;
    font-size: 20px;
    color: #ffffff;
    padding-left: 20%;
    z-index: 2002;
    width: 340px;
    height: 60px;
    background-color: #1790ff;
    border-radius: 40px;
    line-height: 60px;
    cursor: pointer;
  }
}
.isAlreadySucscirbe {
  background-color: #aaaaaa !important;
}
.details_content {
  //  height: 200px;
  h1 {
    width: 180px;
    height: 18px;
    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #333333;
    opacity: 1;
  }
  p {
    margin-top: 20px;
    width: 258px;
    height: 16px;
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #aaaaaa;
    opacity: 1;
  }
}
.detauls_content {
  margin-top: 20px;
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  line-height: 31px;
  color: #333333;
  padding-left: 30px;
  border-left: #1890ff solid 4px;
}
.multiple-player {
  height: 800px;
}
::v-deep .prism-big-play-btn {
  top: 50%;
  left: 50% !important;
  transform: translate(-32px, -32px);
}
</style>
